
import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'

@Component
export default class DarkModeBtn extends Vue {
  @Prop() darkMode!: Boolean

  btnOnClick () {
    this.$emit('click')
  }
}
